module.exports = __webpack_public_path__ + "img/2.21473c53.png";